import type { MagentoApiGetCustomerCartQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const getCustomerCartEndpoint = (builder: MagentoApiBuilder) => ({
  getCustomerCart: builder.query<MagentoApiGetCustomerCartQueryResponse, void>({
    query: () => ({
      method: "getCustomerCart",
      params: [],
    }),
    providesTags: [TAGS.CART_ID],
  }),
});
